/**
 * @fileoverview POST handler for the "/apps/:app_group_id/start_import" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { startCsvImportCacheKeys } from "./constants";
import type { PostStartCsvImportProps } from "./types";

export const postStartCsvImport = reactQueryMutationAdapter(
  startCsvImportCacheKeys,
  (props: PostStartCsvImportProps): Promise<void> => {
    return fetch(`/apps/${props.app_group_id}/start_import`, "POST", props);
  }
);
